import { createFeatureSelector, createSelector } from '@ngrx/store';
import _ from 'lodash-es';
import {
  selectListedUnlistedFilterAvailabilityFeedIdAppSetting,
  selectTradingAddressAvailabilityFeedIdAppSetting,
  selectTradingAddressAvailabilityTPCOrbisFeedIdAppSetting,
} from '../../../../app.selectors';
import { StudySearchFilter } from '../../../../models/studySearchFilter.model';
import { StudyDataState } from '../../../reducers';
import { selectStudyData } from '../../../study.selectors';
import { DatabaseType } from '../../../_study_constants';

export const selectStudyDataState = createFeatureSelector<StudyDataState>('selectedStudy');

export const selectSearchStrategy = createSelector(selectStudyData, (study) =>
  !study || !study.searchStrategies[0] ? undefined : study.searchStrategies[0]
);

export const selectSearchStrategyDatabases = createSelector(selectStudyData, (study) =>
  !study || !study.searchStrategies[0] ? [] : study.searchStrategies[0].studySearchStrategyDatabases
);

export const selectSearchStrategyDatabaseIds = createSelector(selectSearchStrategyDatabases, (dbs) => _.map(dbs, 'databaseId'));

export const isSearchStrategyDatabaseSelected = createSelector(selectSearchStrategyDatabases, (dbs) => dbs.length > 0);

export const selectSearchStrategyFilters = createSelector(selectStudyData, (study) =>
  !study || !study.searchStrategies[0]
    ? []
    : _.sortBy(
        _.filter(study.searchStrategies[0].searchFilters, function (f) {
          return f.isActive;
        }),
        (s) => s.displayOrder
      )
);

export const selectSearchStrategyFiltersCount = createSelector(selectSearchStrategyFilters, (filters) => (filters.length === 0 ? 0 : filters.length));

export const selectSearchStrategyActiveFiltersCount = createSelector(selectSearchStrategyFilters, (filters) =>
  filters.length === 0
    ? 0
    : _.filter(filters, function (f) {
        return f.filter.isActive;
      }).length
);

export const selectSearchStrategyFilter = (id: number) =>
  createSelector(selectSearchStrategyFilters, (filters) => {
    return !id || filters.length === 0
      ? undefined
      : _.find(filters, function (f: StudySearchFilter) {
          return f.studySearchFilterId === id;
        });
  });

export const selectSearchStrategyBooleanLogic = createSelector(selectStudyData, (study) =>
  !study || !study.searchStrategies[0] ? undefined : study.searchStrategies[0].booleanLogic
);

export const selectSearchStrategyId = createSelector(selectStudyData, (study) =>
  !study || !study.searchStrategies[0] ? undefined : study.searchStrategies[0].studySearchStrategyId
);

export const selectFilingTypeId = createSelector(selectStudyData, (study) =>
  !study || !study.searchStrategies[0] || !study.searchStrategies[0].filingTypeId ? null : study.searchStrategies[0].filingTypeId
);

export const isTradingAddressAvailable = createSelector(
  selectTradingAddressAvailabilityFeedIdAppSetting,
  selectTradingAddressAvailabilityTPCOrbisFeedIdAppSetting,
  selectSearchStrategyDatabases,
  (feedId, orbisFeedId, dbs) =>
    dbs.length === 1 &&
    (((dbs[0].databaseId === DatabaseType.Osiris || dbs[0].databaseId === DatabaseType.TPCOrbisListed) && dbs[0].databaseFeedId >= feedId) ||
      ((dbs[0].databaseId === DatabaseType.TPCOrbisAPAC ||
        dbs[0].databaseId === DatabaseType.TPCOrbisEurope ||
        dbs[0].databaseId === DatabaseType.TPCOrbisEuropeVLLM ||
        dbs[0].databaseId === DatabaseType.TPCOrbisALL) &&
        dbs[0].databaseFeedId >= orbisFeedId))
);

export const isListedUnlistedFilterAvailable = createSelector(
  selectListedUnlistedFilterAvailabilityFeedIdAppSetting,
  selectSearchStrategyDatabases,
  (feedId, dbs) =>
    dbs.length === 1 &&
    dbs[0].databaseId !== DatabaseType.CompustatGlobal &&
    dbs[0].databaseId !== DatabaseType.CompustatNA &&
    dbs[0].databaseId !== DatabaseType.OneSource &&
    dbs[0].databaseFeedId >= feedId
);

export const isTPCOrbisSelected = createSelector(
  selectSearchStrategyDatabases,
  (dbs) =>
    (dbs.length === 1 && dbs[0].databaseId === DatabaseType.TPCOrbisAPAC) ||
    dbs[0].databaseId === DatabaseType.TPCOrbisEurope ||
    dbs[0].databaseId === DatabaseType.TPCOrbisListed ||
    dbs[0].databaseId === DatabaseType.TPCOrbisEuropeVLLM ||
    dbs[0].databaseId === DatabaseType.TPCOrbisALL
);
